import { UPDATE_NAV } from '../constants/actionLocal';
import initialState from '../store/initialState';
import { updateObjectInState } from '../helpers/data';

export default (state = initialState.nav, { type, payload }) => {
  switch (type) {
    case UPDATE_NAV:
      return updateObjectInState(state, payload);
    default:
      return state;
  }
};
